class GGCarousel extends HTMLElement {
  constructor() {
    super();
    this.elementTop = 0;
    this.elementBottom = 0;
    this.isVisible = false;
    this.rafId = null;
  }

  connectedCallback() {
    if (window.innerWidth < 750) {
      this.updateElementPosition();
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
      this.handleScroll(true);
    }
  }

  disconnectedCallback() {
    if (window.innerWidth < 750) {
      window.removeEventListener('scroll', this.handleScroll.bind(this));
      cancelAnimationFrame(this.rafId); // Cleanup
    }
  }

  updateElementPosition() {
    const rect = this.getBoundingClientRect();
    this.elementBottom = rect.top + rect.height;
  }

  handleScroll(isInitialLoad = false) {
    cancelAnimationFrame(this.rafId); // Cancel previous frame if it exists

    this.rafId = requestAnimationFrame(() => {
      const scrollPosition = window.scrollY;

      if (scrollPosition >= this.elementBottom) {
        if (this.isVisible || isInitialLoad) {
          this.classList.add('carousel--is-hidden');
          this.isVisible = false;
        }
      } else {
        if (!this.isVisible) {
          this.classList.remove('carousel--is-hidden');
          this.isVisible = true;
        }
      }
    });
  }
}

window.customElements.define('gg-carousel', GGCarousel);
